import { useState } from 'react';

export type TEnv = 'development' | 'production' | 'staging';

interface EnvironmentState {
  currentEnv: TEnv;
}

const determineEnvironment = (): TEnv => {
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT as TEnv;
  } else if (process.env.NODE_ENV === 'production') {
    return 'production';
  } else if (process.env.NODE_ENV === 'test') {
    return 'staging';
  } else {
    return 'development';
  }
};

const initialEnvironment: EnvironmentState = {
  currentEnv: determineEnvironment(),
};

const useEnvironment = (): EnvironmentState => {
  const [environment] = useState<EnvironmentState>(initialEnvironment);
  return environment;
};

export default useEnvironment;
